import {
  type CapturePulseBlockMutation,
  type CapturePulseBlockMutationVariables,
  useCapturePulseBlockMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

type CapturePulseBlockResponse = Extract<
  NonNullable<CapturePulseBlockMutation['capturePulseBlock']>,
  { __typename: 'PulseV1CapturePulseBlockResponse' }
>;

export const useCapturePulseBlock = withStandardMutationHook<
  CapturePulseBlockMutation,
  CapturePulseBlockResponse,
  CapturePulseBlockMutationVariables,
  'capturePulseBlock'
>(useCapturePulseBlockMutation, 'capturePulseBlock');
